import { useState } from "react";
import { Form, Button } from "react-bootstrap";

const DonationForm = () => {
  const [amount, setAmount] = useState(0);
  const [customAmount, setCustomAmount] = useState("");
  const [frequency, setFrequency] = useState("monthly");
  const [donor, setDonor] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });

  const handleAmountClick = (value) => {
    setAmount(value);
    setCustomAmount(""); // Clear custom amount if preset is clicked
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const finalAmount = customAmount ? customAmount : amount;

    const donationData = {
      amount: finalAmount,
      frequency,
      first_name: donor.firstName,
      last_name: donor.lastName,
      email: donor.email,
    };

    try {
      const response = await fetch(
        "https://impactstoriesfund.org/backend/public/api/donate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(donationData),
        }
      );

      const data = await response.json();

      if (data.success && data.payment_data && data.payment_data.url) {
        window.location.href = data.payment_data.url; // Redirect to IntaSend checkout
      } else {
        alert("Payment initiation failed. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while processing your payment.");
    }
  };

  return (
    <Form
      onSubmit={handleSubmit}
      className="donation-form p-4 shadow rounded bg-white"
    >
      <h3 className="text-center mb-4">Make a Donation</h3>

      {/* Preset Donation Amounts */}
      <div className="mb-3 d-flex gap-2 flex-wrap">
        {[5, 10, 20, 50, 100].map((value) => (
          <Button
            key={value}
            variant={amount === value ? "primary" : "outline-primary"}
            onClick={() => handleAmountClick(value)}
          >
            ${value}
          </Button>
        ))}
      </div>

      {/* Custom Amount Input */}
      <Form.Group className="mb-3">
        <Form.Control
          type="number"
          placeholder="Enter custom amount"
          value={customAmount}
          onChange={(e) => {
            const value = Math.max(0, Number(e.target.value));
            setCustomAmount(value);
            setAmount(0);
          }}
        />
      </Form.Group>

      {/* Donation Frequency */}
      <Form.Group className="mb-3">
        <Form.Label>Donation Frequency</Form.Label>
        <Form.Select
          value={frequency}
          onChange={(e) => setFrequency(e.target.value)}
        >
          <option value="one-time">One-Time</option>
          <option value="yearly">Yearly</option>
          <option value="monthly">Monthly</option>
          <option value="weekly">Weekly</option>
          <option value="daily">Daily</option>
        </Form.Select>
      </Form.Group>

      {/* Donor Details */}
      <Form.Group className="mb-3">
        <Form.Control
          type="text"
          placeholder="First Name"
          value={donor.firstName}
          onChange={(e) => setDonor({ ...donor, firstName: e.target.value })}
          required
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Control
          type="text"
          placeholder="Last Name"
          value={donor.lastName}
          onChange={(e) => setDonor({ ...donor, lastName: e.target.value })}
          required
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Control
          type="email"
          placeholder="Email Address"
          value={donor.email}
          onChange={(e) => setDonor({ ...donor, email: e.target.value })}
          required
        />
      </Form.Group>

      {/* Submit Button */}
      <Button type="submit" variant="warning" className="w-100">
        Make Payment
      </Button>
    </Form>
  );
};

export default DonationForm;
